export default __webpack_public_path__ + "static/media/image-6.6f788577.jpeg";